import {
    CONFIRMED_CREATE_SYMPTOM_MEDICINE_MAPPING_ACTION,
    CONFIRMED_DELETE_SYMPTOM_MEDICINE_MAPPING_ACTION,
    CONFIRMED_EDIT_SYMPTOM_MEDICINE_MAPPING_ACTION,
    CONFIRMED_GET_SYMPTOM_MEDICINE_MAPPINGS,
  } from "../actions/SymptomMedicineType";
  
  import {
    createSymptomMedicineMapping,
    updateSymptomMedicineMapping,
    getSymptomMedicineMappings,
    deleteSymptomMedicineMapping,
    formatSymptomMedicineMappings
  } from "../../services/SymptomMedicineMappingService";
  
  import swal from "sweetalert";
import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";
  
  // Get token from Redux or fallback to localStorage
  function getAuthToken(getState) {
    const stateToken = getState().auth?.authKey;
    if (stateToken) return stateToken;
  
    const storedUser = localStorage.getItem('userDetails');
    return storedUser ? JSON.parse(storedUser).token : null;
  }
  
  export function getSymptomMedicineMappingsAction( pagination = false, pageid = 0) {
    return async (dispatch, getState) => {
      try {
        const token = getAuthToken(getState);
        //console.log(admin_id, pagination, pageid, token);
        const response = await getSymptomMedicineMappings( pagination, pageid, token);
  
        if (response && response.status === 200 && response.data) {
          if (response.data.status === "success" && response.data.data) {
            const mappings = formatSymptomMedicineMappings(response.data.data);
            dispatch({ type: CONFIRMED_GET_SYMPTOM_MEDICINE_MAPPINGS, payload: mappings });
          } else {
            handleError("Failed to get symptom medicine mappings: Server error");
          }
        } else {
          handleError("Failed to get symptom medicine mappings: Network error");
        }
      } catch (error) {
        console.error("API Error:", error.response || error);
        showErrorAlert("Failed to get symptom medicine mappings");
      }
    };
  }
  
  export function deleteSymptomMedicineMappingAction(mapping, history) {
    return async (dispatch) => {
      try {
        const response = await deleteSymptomMedicineMapping(mapping);
        if (response?.data?.status === "success") {
          dispatch({ 
            type: CONFIRMED_DELETE_SYMPTOM_MEDICINE_MAPPING_ACTION, 
            payload: { symptom_medicine_id: mapping.symptom_medicine_id } 
          });
        handleSuccess("Symptom-Medicine Mapping deleted successfully!");
        }else{
          showErrorAlert(response?.data?.message || "Failed to delete mapping");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to delete symptom-medicine mapping");
      }
    };
  }
  
  export function createSymptomMedicineMappingAction(mappingData, history) {
    return async (dispatch, getState) => {
      try {
        const token = getAuthToken(getState);
        const currentAdmin = getState().auth?.admin;
        const admin_id = currentAdmin?.admin_id;

        const newMapping = { 
          ...mappingData, 
          admin_id: admin_id || mappingData.admin_id  // prioritize Redux, fallback to passed
        };
        const response = await createSymptomMedicineMapping(newMapping, token);
  
        if (response?.data?.status === "success") {
          // Instead of dispatching locally, refetch from backend
          dispatch(getSymptomMedicineMappingsAction());
  
          handleSuccess("Mapping created successfully!");
          if (history) history("/symptom-medicine-mapping");
        } else {
          showErrorAlert(response?.data?.message || "Failed to create mapping");
        }
      } catch (error) {
        console.error("API Error:", error);
        showErrorAlert(error.response?.data?.message || "Failed to create mapping");
      }
    };
  }
  
  
  
  export function updateSymptomMedicineMappingAction(mappingData, history) {
    return async (dispatch, getState) => {
      try {
        const token = getAuthToken(getState);
        const currentAdmin = getState().auth?.admin;
        const admin_id = currentAdmin?.admin_id;

      const updatedMapping = {
        ...mappingData,
        admin_id: admin_id || mappingData.admin_id,
      };

        const response = await updateSymptomMedicineMapping(mappingData, token);
  
        if (response?.data?.status === "success") {
          dispatch({ 
            type: CONFIRMED_EDIT_SYMPTOM_MEDICINE_MAPPING_ACTION, 
            payload: updatedMapping 
          });
          handleSuccess("Mapping updated successfully!");
          if (history) history.push("/symptom-medicine-mapping");
        } else {
          showErrorAlert(response?.data?.message || "Failed to update mapping");
        }
      } catch (error) {
        console.error("API Error:", error);
        showErrorAlert(error.response?.data?.message || "Failed to update mapping");
      }
    };
  }
  